var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 138.4 256",
    style: {
      enableBackground: "new 0 0 138.4 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000162346820066803251220000003580475076746699656_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22.9,128.2c1.9,1.2,3.7,2.6,5.4,4c34.2,34.1,68.5,68.2,102.7,102.3c1.1,1,2.1,2.1,3.2,3.2 c5.1,5.2,5.5,11.2,1.2,15.4s-10.1,3.8-15.4-1.4C81.6,213.3,43.1,175,4.7,136.6c-6.2-6.2-6.2-11.1-0.1-17.2 C43,81.1,81.4,42.7,119.9,4.4c0.9-1,1.9-1.9,3-2.6c3.8-2.7,9-2.3,12.4,1c3.4,3.2,4,8.4,1.5,12.3c-1.3,1.8-2.7,3.4-4.3,4.8 C97.8,54.5,63.1,89.1,28.4,123.7C27.1,124.9,25.6,126,22.9,128.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.9133fc8a074c0c15332f85b8f7080af5.svg";
export { ForwardRef as ReactComponent };